module.exports = __webpack_public_path__ + "img/twitter.3e3e664b.png";